// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/downloadCenter';

/** 创建下载任务 POST /api/task/create */
export async function apiTaskCreate(body: APIDownloadCenter.__, options?: CustomRequestOptions) {
  return request<APIDownloadCenter.DownloadCenterOperateTaskResponse>('/api/task/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 根据token下载文件 GET /api/task/file/download */
export async function taskFileDownload(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: APIDownloadCenter.taskFileDownloadParams,
  options?: CustomRequestOptions,
) {
  return request<any>('/api/task/file/download', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 根据downloadId生成下载链接 GET /api/task/file/download/url/query */
export async function downloadUrlQuery(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: APIDownloadCenter.downloadUrlQueryParams,
  options?: CustomRequestOptions,
) {
  return request<APIDownloadCenter.QueryDownloadUrlResponse>('/api/task/file/download/url/query', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 查询最近七天的下载任务 GET /api/task/query */
export async function apiTaskQuery(options?: CustomRequestOptions) {
  return request<APIDownloadCenter.TbDownloadQueryOwnerResponse>('/api/task/query', {
    method: 'GET',
    ...(options || {}),
  });
}
